/**
 * Experience kit claim.
 *
 * The page takes one optional field; everything else the order needs is collected by Shopify
 * checkout, which validates the address and creates the customer record properly.
 *
 * The cart is emptied first on purpose. Free shipping on the kit is a rate that only matches
 * order totals of $0.00-$0.01, so anything else already sitting in the cart would push the total
 * over that line and the kit would arrive with postage attached.
 */
(() => {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const post = async (path, body) => {
    const res = await fetch(root().replace(/\/$/, '') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body || {}),
    });
    let json = null;
    try { json = await res.json(); } catch (e) { /* /cart/clear.js can answer with no body */ }
    if (!res.ok) throw new Error((json && (json.description || json.message)) || 'Something went wrong.');
    return json;
  };

  const claim = async (box) => {
    const button = box.querySelector('[data-sp-kit-submit]');
    const error = box.querySelector('[data-sp-kit-error]');
    const social = box.querySelector('[data-sp-kit-social]');
    const variantId = Number(box.dataset.variantId);
    const discount = (box.dataset.discount || '').trim();
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.classList.add('is-busy');
    if (error) error.hidden = true;

    try {
      await post('/cart/clear.js');
      await post('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });

      const handle = (social && social.value || '').trim().replace(/^@+/, '');
      if (handle) {
        // Checkout has nowhere to put this, so it rides on the order as an attribute.
        await post('/cart/update.js', { attributes: { 'Social handle': '@' + handle } });
      }

      const url = discount
        ? `${root()}checkout?discount=${encodeURIComponent(discount)}`
        : `${root()}checkout`;
      window.location.assign(url);
    } catch (e) {
      button.disabled = false;
      button.classList.remove('is-busy');
      if (error) {
        error.textContent = e.message;
        error.hidden = false;
      }
    }
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;
    const button = event.target.closest('[data-sp-kit-submit]');
    if (!button) return;
    event.preventDefault();
    const box = button.closest('[data-sp-kit]');
    if (box) claim(box);
  });

  // Enter in the handle field should submit, the way it would in a real form.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.closest) return;
    const input = event.target.closest('[data-sp-kit-social]');
    if (!input) return;
    event.preventDefault();
    const box = input.closest('[data-sp-kit]');
    if (box) claim(box);
  });
})();
